import { Injectable } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { LoadingCircleComponent } from '../components/loading-circle/loading-circle.component';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingCtrl: any;
  private showLoading$ = new BehaviorSubject<number>(0);
  private showing = false;

  constructor(
    private loadingController: LoadingController,
    private modalController: ModalController) { }

  /**
   * initializes the loading controller
   */
  async init() {
    await this.createLoader();
    this.showLoading$.subscribe(count => this.showLoader(count));
  }

  /**
   * show the loading control
   */
  async show(msg = '') {
    if (msg) {
      console.log(msg);
    }
    this.showLoading$.next(this.showLoading$.value + 1);
  }

  /**
   * hide the loading control
   */
  hide(msg = ''): void {
    if (msg) {
      console.log(msg);
    }

    setTimeout(() => {
      this.loadingCtrl.dismiss();
    }, 10);

    const val = this.showLoading$.value;
    this.showLoading$.next(val > 0 ? val - 1 : 0);
  }

  // ================================================
  private async showLoader(count: number) {
    if (count > 0) {
      if (!this.showing) {
        this.showing = true;
        await this.createLoader();
        this.loadingCtrl.present();
      }
    } else if (count === 0 && this.showing) {
      this.showing = false;
      setTimeout(() => {
        this.loadingCtrl.dismiss();
      }, 10);
    }
  }

  // --------------------------------------------
  private async createLoader() {
    /*
    this.loadingCtrl = await this.loadingController.create({
      message: 'Please wait...',
      duration: 10000,
      translucent: true,
      cssClass: 'loading-spinner'
    });*/
    
    this.loadingCtrl = await this.modalController.create({
      component: LoadingCircleComponent,
      cssClass: 'loading-modal'
    });
  }
}
